import { useModal } from '@ebay/nice-modal-react'
import { useHistory } from 'react-router-dom'
import { StringParam, useQueryParams, withDefault } from 'use-query-params'
import { Icon } from '@iconify/react'
import { Spin, useGlobalState, useMessage } from '@pepper/ui'

import CategorySection from '../CategorySection'
import RecentCategoryCard from '../RecentCategoryCard'
import RecommendedCategoryCard from '../RecommendedCategoryCard'

import { useCreateCategory } from 'utils/hooks/content-ideas/useCreateCategory'

import { KeywordCategory } from 'container/SEOTools/types'

import s from './Categories.module.css'

type Props = {
  domainId: string
  companyId: string
  isLoading: boolean
  recentCategories?: KeywordCategory[] | null
  recommendedCategories?: string[]
  isContentIdeasPage?: boolean
}

const Categories = ({
  domainId,
  companyId,
  recentCategories,
  recommendedCategories,
  isLoading,
  isContentIdeasPage,
}: Props) => {
  const history = useHistory()
  const { showError } = useMessage()
  const { permissions } = useGlobalState()
  const { show: showUpsellBanner } = useModal('buy-cmp')
  const [_, setQueryParams] = useQueryParams({
    category_id: withDefault(StringParam, undefined),
    step: withDefault(StringParam, undefined),
  })
  const { mutateAsync: createCategory } = useCreateCategory()

  const hasCMPPermission = permissions?.cmp

  const handleRecommendedCategoryClick = async (category: string) => {
    if (!hasCMPPermission) {
      showUpsellBanner()
      return
    }
    setQueryParams({
      step: 'themes',
    })
    localStorage.setItem('currently_loading_category', category)
    try {
      const response = await createCategory({
        companyId,
        domainId,
        category,
      })
      if (response.data) {
        setQueryParams({
          category_id: response.data.id,
        })
      }
    } catch (error) {
      history.goBack()
      showError(error?.response?.data?.message)
    }
    localStorage.removeItem('currently_loading_category')
  }

  return (
    <Spin spinning={isLoading} size="large" className={s.wrapper}>
      {!!recentCategories && (
        <CategorySection
          isContentIdeasPage={isContentIdeasPage}
          title="Recent Categories"
          icon={<Icon icon="lucide:search" width={16} height={16} />}
        >
          {recentCategories.map(category => (
            <RecentCategoryCard key={category.id} category={category} />
          ))}
        </CategorySection>
      )}
      {!!recommendedCategories && recommendedCategories.length > 0 && (
        <CategorySection
          isContentIdeasPage={isContentIdeasPage}
          title={`Recommended Categories (${recommendedCategories.length})`}
          icon={<Icon icon="lucide:star" width={16} height={16} />}
        >
          {recommendedCategories.map((category, index) => (
            <RecommendedCategoryCard
              key={category}
              category={category}
              onClick={() => handleRecommendedCategoryClick(category)}
              dataId={`reco-cat-${index}-content-ideas-button`}
            />
          ))}
        </CategorySection>
      )}
    </Spin>
  )
}

export default Categories
